import './component.scss'
import 'PackWerkNurikaeSite/pages/company/show/partials/star_rating/component'
import 'PackWerkNurikaeSite/pages/company/show/partials/company_card_rate_table/component'

// コメント展開機能
const initializeCommentToggle = () => {
  const moreButtons = document.querySelectorAll('.js-review-card__more-button')

  moreButtons.forEach(button => {
    const comment = button.closest('.review-card__comment-container').querySelector('.js-review-card__comment')

    // 3行以下の場合は「もっと見る」ボタンを非表示にする
    const commentHeight = comment.scrollHeight
    const displayHeight = comment.offsetHeight

    if (commentHeight <= displayHeight) {
      button.classList.add('hidden')
      return
    }

    // ボタンはリンク動作を無効化し、カードのリンクとして動作
    button.addEventListener('click', function(e) {
      e.stopPropagation()
      // ボタンをクリックした時はカードのリンク先に遷移する
      window.location.href = button.closest('.review-card').href
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  // コメント展開機能を初期化
  initializeCommentToggle()
})
